import(/* webpackMode: "eager" */ "/app/apps/frontend/app/(dashboard)/create/page.tsx");
